/* Commercial Source furniture product page: options, swatches, photo, price, quantity, downloads. */
(function () {
  var root = document.getElementById('cs-furn');
  var dataEl = document.getElementById('cs-furn-data');
  if (!root || !dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var idInput = document.getElementById('cs-furn-id');
  var priceEl = document.getElementById('cs-furn-price');
  var listEl = document.getElementById('cs-furn-list');
  var compareEl = document.getElementById('cs-furn-compare');
  var imgEl = document.getElementById('cs-furn-img');
  var addBtn = document.getElementById('cs-furn-add');
  var helpEl = document.getElementById('cs-furn-help');
  var fieldsets = Array.prototype.slice.call(root.querySelectorAll('.cs-furn-option'));

  function money(cents) {
    var d = cents / 100;
    var whole = Math.round(d) === d;
    return '$' + d.toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
  }

  function current() {
    var id = Number(idInput.value);
    for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === id) return data.variants[i];
    return data.variants[0];
  }

  var selected = current().options.slice();

  function findVariant(opts) {
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i], ok = true;
      for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }

  function exists(index, value) {
    var test = selected.slice();
    test[index] = value;
    return !!findVariant(test);
  }

  function refreshButtons() {
    fieldsets.forEach(function (fs) {
      var index = Number(fs.getAttribute('data-index'));
      fs.querySelectorAll('[data-value]').forEach(function (b) {
        var v = b.getAttribute('data-value');
        b.setAttribute('aria-pressed', v === selected[index] ? 'true' : 'false');
        var can = exists(index, v);
        b.classList.toggle('cs-is-unavailable', !can);
      });
      var picked = fs.querySelector('[data-picked]');
      if (picked) picked.textContent = selected[index];
    });
  }

  function setImage(src) {
    if (!src || !imgEl) return;
    imgEl.src = src;
  }

  var images = data.images || [];
  var colorIndex = typeof data.colorIndex === 'number' ? data.colorIndex : -1;
  var thumbsWrap = document.getElementById('cs-furn-thumbs');
  var sampleEl = document.getElementById('cs-furn-sample');
  var sampleChip = document.getElementById('cs-furn-sample-chip');
  var sampleName = document.getElementById('cs-furn-sample-name');

  function imageById(id) {
    for (var i = 0; i < images.length; i++) if (images[i].id === id) return images[i];
    return null;
  }
  function firstGeneral() {
    for (var i = 0; i < images.length; i++) if (images[i].general) return images[i];
    return images[0] || null;
  }

  // Show the variant's own photo (or a general photo), only the matching thumbnails,
  // and a "Color sample" when the photo is not in the picked color.
  function updatePhotos(v) {
    var own = v.imageId ? imageById(v.imageId) : null;
    var main = own || firstGeneral();
    if (main) setImage(main.src);
    if (thumbsWrap) {
      var shown = 0;
      thumbsWrap.querySelectorAll('.cs-furn-thumb').forEach(function (t) {
        var id = Number(t.getAttribute('data-img-id'));
        var show = t.hasAttribute('data-general') || (own && id === own.id);
        t.hidden = !show;
        if (show) shown++;
      });
      thumbsWrap.hidden = shown < 2;
    }
    if (sampleEl && colorIndex > -1) {
      var color = v.options[colorIndex];
      var need = !own;
      if (own) {
        for (var i = 0; i < data.variants.length; i++) {
          var o = data.variants[i];
          if (o.imageId === own.id && o.options[colorIndex] !== color) { need = true; break; }
        }
      }
      sampleEl.hidden = !need;
      if (sampleName) sampleName.textContent = color;
      var sw = data.swatches && data.swatches[color];
      if (sampleChip) sampleChip.style.backgroundImage = sw ? 'url("' + sw + '")' : '';
    }
  }

  function updateDownloads() {
    var outletIndex = data.options.indexOf('Outlets');
    var withOutlets = outletIndex > -1 && /with/i.test(selected[outletIndex] || '');
    root.querySelectorAll('[data-cs-when]').forEach(function (li) {
      var when = li.getAttribute('data-cs-when');
      var show = when === 'all' || (when === 'outlets' && withOutlets) || (when === 'no-outlets' && !withOutlets);
      li.hidden = !show;
    });
  }

  function apply() {
    var v = findVariant(selected);
    if (!v) {
      addBtn.disabled = true;
      helpEl.hidden = false;
      helpEl.textContent = 'That combination is not available. Pick another option.';
      refreshButtons();
      return;
    }
    idInput.value = v.id;
    priceEl.textContent = money(v.price);
    if (v.compare && v.compare > v.price) {
      compareEl.textContent = money(v.compare);
      listEl.hidden = false;
    } else {
      listEl.hidden = true;
    }
    addBtn.disabled = !v.available;
    helpEl.hidden = v.available;
    helpEl.textContent = v.available ? '' : 'Sold out. Email us and we will find you a date.';
    updatePhotos(v);
    refreshButtons();
    updateDownloads();
    if (window.history && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url.toString());
    }
  }

  fieldsets.forEach(function (fs) {
    var index = Number(fs.getAttribute('data-index'));
    fs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-value]');
      if (!b) return;
      selected[index] = b.getAttribute('data-value');
      if (!findVariant(selected)) {
        // Keep the tapped value and pick the first variant that has it.
        for (var i = 0; i < data.variants.length; i++) {
          if (data.variants[i].options[index] === selected[index]) { selected = data.variants[i].options.slice(); break; }
        }
      }
      apply();
    });
  });

  root.querySelectorAll('.cs-furn-thumb').forEach(function (t) {
    t.addEventListener('click', function () { setImage(t.getAttribute('data-src')); });
  });

  var qty = 1;
  var qtyInput = document.getElementById('cs-furn-qty');
  var qtyOut = document.getElementById('cs-furn-qty-out');
  var minus = document.getElementById('cs-furn-minus');
  function setQty(n) {
    qty = Math.max(1, Math.min(99, n));
    qtyInput.value = qty;
    qtyOut.textContent = qty;
    minus.disabled = qty <= 1;
  }
  minus.addEventListener('click', function () { setQty(qty - 1); });
  document.getElementById('cs-furn-plus').addEventListener('click', function () { setQty(qty + 1); });
  setQty(1);

  refreshButtons();
  updateDownloads();
})();
